var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Gutachter",
          },
          on: { save: _vm.saveAppraiserFormData },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gutachterfirma",
                  "options-loader": _vm.loadAppraiserFirmOptions,
                  property: "appraiserFirm",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm.firmData.name
                              ? _c("span", [
                                  _c("b", [_vm._v(_vm._s(_vm.firmData.name))]),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.street
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.street)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.postalCode || _vm.firmData.city
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.firmData.postalCode) +
                                      " " +
                                      _vm._s(_vm.firmData.city)
                                  ),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.countryName
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.countryName)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm.firmData.phone
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.phone)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.email
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:" + _vm.firmData.email,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.firmData.email))]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2679382243
                ),
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  dependencies: ["appraiserFirm"],
                  "form-context": _vm.formContext,
                  label: "Gutachterbenutzer",
                  "options-loader": _vm.loadAppraiserUserOptions,
                  property: "appraiserUser",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm.userData.name
                              ? _c("span", [
                                  _c("b", [_vm._v(_vm._s(_vm.userData.name))]),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.street
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userData.street)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.postalCode || _vm.userData.place
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.userData.postalCode) +
                                      " " +
                                      _vm._s(_vm.userData.place)
                                  ),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.countryName
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userData.countryName)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm.userData.phone
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userData.phone)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.email
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:" + _vm.userData.email,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.userData.email))]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4278266274
                ),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formContext.permissions.canSendOrderToAppraiser
            ? _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.loadMailAndOpenMailModal },
                    },
                    [
                      _c("i", { staticClass: "inticon-autoclaim_mail" }),
                      _vm._v(" Gutachter-Link\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        "cancel-disabled": true,
                        "hide-footer": true,
                        "ok-disabled": true,
                        size: "lg",
                        title: "Gutachter-Link versenden",
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm.appraiserMailDocument &&
                          _vm.appraiserMailDocumentPath
                            ? {
                                key: "default",
                                fn: function ({ visible }) {
                                  return [
                                    visible
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "print-documents-modal-content",
                                          },
                                          [
                                            _c(
                                              "csp-record-detail-document-mail",
                                              {
                                                ref: "documentMail",
                                                attrs: {
                                                  "mail-document":
                                                    _vm.appraiserMailDocument,
                                                  path: _vm.appraiserMailDocumentPath,
                                                },
                                                on: {
                                                  "cancel-mail": _vm.cancelMail,
                                                  "close-mail-modal": function (
                                                    $event
                                                  ) {
                                                    _vm.isMailModalOpen = false
                                                  },
                                                  "mail-sent": function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "document-generated"
                                                    )
                                                  },
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.isMailModalOpen,
                        callback: function ($$v) {
                          _vm.isMailModalOpen = $$v
                        },
                        expression: "isMailModalOpen",
                      },
                    },
                    [
                      _vm.isMailModalLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "loading-content-container d-flex justify-content-center",
                            },
                            [_c("csp-loading-indicator")],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "clear-float" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }